export const inputStyles = {
  display: 'none'
};
